import script from "./newPaymentGetWay.vue?vue&type=script&setup=true&lang=js"
export * from "./newPaymentGetWay.vue?vue&type=script&setup=true&lang=js"

import "./newPaymentGetWay.vue?vue&type=style&index=0&id=49b2008e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49b2008e"]])

export default __exports__